import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
// Servicios de la API GALAVAIL
import { GalavailServiceEcommer } from 'clientwsGalavail';
import { CompanyService } from 'src/app/services/company/company.service';
import { CruiseService } from 'src/app/services/cruise.service';
import { isNullOrUndefined } from 'util';
import { UtilDate } from 'src/app/shared/util/util-date';
var MY_DATE_FORMAT = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};
var ɵ0 = MY_DATE_FORMAT;
var SearchComponent = /** @class */ (function () {
    function SearchComponent(router, activatedRoute, galavailServiceEcommer, companyService, cruiseService, utilDate) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.galavailServiceEcommer = galavailServiceEcommer;
        this.companyService = companyService;
        this.cruiseService = cruiseService;
        this.utilDate = utilDate;
        this.valuesChange = new EventEmitter();
        this.resetValueContentResult = new EventEmitter();
        this.resetShowLoading = new EventEmitter();
        this.isPromoOnly = new EventEmitter();
        this.isPromo2x1 = new EventEmitter();
        this.CHARTER_PROMO = -1;
        this.PROMO_ONLY = 1;
        this.PROMO_2X1 = 2567;
        this.promotionsList = [
            { label: '2 x 1', value: '2567' },
            { label: '$ OFF', value: '2563' },
            { label: '% OFF', value: '2564' },
            { label: 'Super Promo', value: '2' },
            { label: 'Promotions Only', value: '1' },
        ];
        this.dataResponse = [];
        this.listBoats = [];
        this.listCategories = [];
        this.promotionsMap = new Map();
        this.visibleAdvanceSearch = false;
        this.buscador = {
            empresa: null,
            barco: null,
            dias: null,
            //fecha: {},
            datefrom: "",
            dateto: "",
            pasajeros: null,
            price: 10000,
            promotion: 'All',
            filter: 'All',
            valores: [],
            promotions: [],
            groupsOnly: false,
            charterOnly: false
        };
        this.selectedPromotions = new FormControl();
        this.selectedLengthCruises = new FormControl();
        this.dateFrom = new FormControl();
        this.dateTo = new FormControl();
        this.minDateFrom = new Date();
        this.minDateTo = new Date();
        this.maxDateTo = new Date();
        this.listYears = [];
        this.listadoMeses = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.listadoMesesn = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        this.listMonthComplete = ['All', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.listMonth = [];
        this.anioActual = new Date().getFullYear();
        this.mesActual = new Date().getMonth();
        this.today = new Date();
        this.monthCurrent = this.today.getMonth();
        this.visibleAdvanceSearch = false;
    }
    SearchComponent.prototype.ngOnInit = function () {
        // console.log('RECIBE PARAMETRO CODIGO EMPRESA:', this.childExample);
        // console.log('RECIBE PARAMETRO CODIGO COLOR MAIN EMPRESA:', this.colorMain);
        // this.visibleAdvanceSearch =
        //   this.promotionsList.length > 0 || this.dataCompany.visibleCharterOnly;
        this.setDataofUrl();
        this.labelAllDays = '';
        this.setPromotionsLinst();
        for (var i in this.catalogueItinerary) {
            if (this.catalogueItinerary[i] === this.catalogueItinerary[this.catalogueItinerary.length - 1]) {
                this.labelAllDays += this.catalogueItinerary[i].description;
            }
            else {
                this.labelAllDays += this.catalogueItinerary[i].description + ', ';
            }
        }
    };
    SearchComponent.prototype.setPromotionsLinst = function () {
        var _this = this;
        this.promotionsList = [];
        if (this.dataCompany) {
            this.dataCompany.listPromotions.forEach(function (element) {
                if (element.status) {
                    _this.promotionsList.push(element);
                }
            });
        }
    };
    SearchComponent.prototype.setDataofUrl = function () {
        var _this = this;
        this.activatedRoute.params.subscribe(function (params) {
            //const auxdate = params['monthYear'] ? params['monthYear'].split('-') : '';
            var daterange = params['daterange'] ? params['daterange'].split('-') : '';
            _this.companyDateRange = _this.companyService.getDateRange().split('-');
            var today = new Date();
            _this.isCharterOnly = params['paxs'] === 'charterOnly';
            if (_this.isCharterOnly) {
                _this.selectedPromotions.setValue([_this.CHARTER_PROMO]);
            }
            _this.buscador = {
                empresa: params['company'],
                barco: params['boat'] ? params['boat'] : 'All',
                dias: params['days'] ? params['days'] : 'All',
                pasajeros: params['paxs'] ? _this.validatePassenger(params['paxs']) : _this.getAllPassenger(),
                /*fecha: {
                  month: auxdate[1] ? auxdate[1] : 'All',
                  year: auxdate[0] ? auxdate[0] : today.getFullYear(),
                },*/
                dateFrom: isNullOrUndefined(daterange[0]) ? (_this.companyDateRange.length != 1 ? _this.companyDateRange[0] : _this.formatDate(today)) : daterange[0],
                dateTo: isNullOrUndefined(daterange[1]) ? (_this.companyDateRange.length != 1 ? _this.companyDateRange[1] : _this.formatDate(today)) : daterange[1],
                price: 0,
                promotion: 'All',
                filter: 'All',
                promotions: [],
                groupsOnly: false,
                charterOnly: _this.isCharterOnly
            };
            var decodeLengthCruises = decodeURIComponent(_this.buscador.dias);
            if (decodeLengthCruises == 'All') {
                decodeLengthCruises = "";
                var catArray_1 = [];
                _this.catalogueItinerary.forEach(function (item) {
                    catArray_1.push(item.code);
                });
                decodeLengthCruises = catArray_1.toString();
            }
            _this.selectedLengthCruises.setValue(decodeLengthCruises.split(','));
            //this.fillYearsAndMonth();
            // console.log('BUSCADOR', this.buscador);
            _this.getListBoats(_this.childExample);
            _this.tempNameEmpresa = _this.buscador.empresa;
            _this.dateFrom.setValue(_this.utilDate.formatStringToDate(_this.buscador.dateFrom));
            _this.dateTo.setValue(_this.utilDate.formatStringToDate(_this.buscador.dateTo));
            _this.setDateTo(_this.dateFrom.value);
            _this.minDateFrom = _this.companyDateRange.length != 1 ? _this.utilDate.formatStringToDate(_this.companyDateRange[0]) : today;
        });
    };
    SearchComponent.prototype.monthsSelected = function (catalogue) {
        var _this = this;
        var months = [];
        catalogue.description.split(',').forEach(function (element) {
            if (element === '0')
                return;
            var yearSearch = _this.buscador.fecha.year;
            var yearCurrent = _this.anioActual;
            if (yearSearch == yearCurrent && parseInt(element) < _this.mesActual + 1)
                return;
            months.push(_this.listMonthComplete[element]);
        });
        return months;
    };
    SearchComponent.prototype.getMonthsSelectedByYear = function (year) {
        var _this = this;
        var months = [];
        this.listYearMonth.forEach(function (element) {
            if (element.code == year) {
                months = _this.monthsSelected(element);
            }
        });
        return months;
    };
    SearchComponent.prototype.getMonths = function () {
        this.listMonth = [];
        this.listadoMeses = this.getMonthsSelectedByYear(this.buscador.fecha.year);
        this.listMonth = this.listadoMeses;
    };
    SearchComponent.prototype.fillYearsAndMonth = function () {
        this.listYears = this.listYearMonth.map(function (item) {
            return item.code;
        });
        this.getMonths();
    };
    SearchComponent.prototype.changeYear = function () {
        this.getMonths();
    };
    SearchComponent.prototype.setDefaultValue = function () {
        var _this = this;
        var today = new Date();
        this.activatedRoute.params.subscribe(function (params) {
            _this.buscador = {
                empresa: params['company'],
                barco: 'Boats',
                dias: 'Days',
                pasajeros: 'Paxs',
                /*fecha: {
                  month: 'Month',
                  year: today.getFullYear(),
                },*/
                price: 0,
                promotion: 'All',
                filter: 'All',
                datefrom: today,
                dateto: today
            };
        });
        // console.log('BUSCADOR', this.buscador);
        // this.listBoats = [];
        // this.getListBoats(this.childExample);
        this.tempNameEmpresa = this.buscador.empresa;
    };
    SearchComponent.prototype.buscarSalidas = function (forma) {
        // console.log(forma);
        if (this.isSearching) {
            return;
        }
        forma.value.dias = this.selectedLengthCruises.value.length == 0 ? 'Days' : this.selectedLengthCruises.value.includes('All') ? 'All' : this.selectedLengthCruises.value.toString();
        if ((forma.value.barco !== 'Boats') && (forma.value.dias !== 'Days') && (forma.value.fecha !== 'Month')
            && (forma.value.selyear !== 'Year') && (forma.value.paxs !== 'Paxs')) {
            // console.log('barco:', forma.value);
            // console.log('dias:', forma.value.dias);
            // console.log('fecha:', forma.value.fecha);
            // console.log('paxs:', forma.value.paxs);
            var yearAux = forma.value.selyear + '-' + forma.value.fecha;
            this.textoMensajeBusqueda = false;
            this.isCharterOnly = (forma.value.paxs === 'charterOnly');
            this.setUrlOrigin();
            this.valuesChange.emit({
                empresa: this.tempNameEmpresa,
                barco: forma.value.barco,
                dias: forma.value.dias,
                pasajeros: this.isCharterOnly ? this.getAllPassenger() : forma.value.paxs,
                //fecha: yearAux,
                price: 0,
                promotion: 'All',
                filter: 'All',
                promotions: this.selectedPromotions.value ? this.getOnlyPromosSelected() : [],
                charterOnly: this.isCharterOnly,
                groupsOnly: this.buscador.groupsOnly,
                dateFrom: this.formatDate(new Date(this.dateFrom.value)),
                dateTo: this.formatDate(new Date(this.dateTo.value))
            });
            //this.buscador.fecha.month = forma.value.fecha;
            this.resetShowLoading.emit(true);
            this.resetValueContentResult.emit(false);
            this.router.navigate([this.buscador.empresa, forma.value.barco, forma.value.dias === 'All' ? forma.value.dias : encodeURIComponent(forma.value.dias), this.formatDate(this.dateFrom.value) + '-' + this.formatDate(this.dateTo.value),
                ((forma.value.paxs === "charterOnly" || (this.isSelectedCharterPromo() && forma.value.paxs === "charterOnly")) ? "charterOnly" : forma.value.paxs)]);
        }
        else {
            this.textoMensajeBusqueda = true;
            // this.resetValueContentResult.emit(false);
        }
    };
    SearchComponent.prototype.onChangePassenger = function () {
        if (this.buscador.pasajeros === "charterOnly") {
            this.selectedPromotions.setValue([this.CHARTER_PROMO]);
        }
    };
    SearchComponent.prototype.selectedLenghtCruiseOption = function (lengthCruise) {
        if (lengthCruise.value != 'All') {
            if (this.selectedLengthCruises.value.length < this.catalogueItinerary.length) {
                var auxArray = this.selectedLengthCruises.value;
                var index = auxArray.indexOf('All');
                if (index != -1) {
                    auxArray.splice(index, 1);
                    this.selectedLengthCruises.setValue(auxArray);
                }
                if (this.selectedLengthCruises.value.length == this.catalogueItinerary.length - 1) {
                    var auxArray2 = this.selectedLengthCruises.value;
                    auxArray2.push('All');
                    this.selectedLengthCruises.setValue(auxArray2);
                }
            }
        }
        else {
            var auxArray_1 = [];
            if (lengthCruise.selected) {
                this.catalogueItinerary.forEach(function (item) {
                    auxArray_1.push(item.code);
                });
            }
            this.selectedLengthCruises.setValue(auxArray_1);
        }
    };
    SearchComponent.prototype.multiselectClose = function (select) {
        switch (select) {
            case 'lengthCruises':
                this.lengthCruises.close();
                break;
            case 'promotions':
                this.promotions.close();
                break;
        }
    };
    SearchComponent.prototype.getOnlyPromosSelected = function () {
        var _this = this;
        var auxArray = this.selectedPromotions.value;
        var resp = [];
        auxArray.forEach(function (item) {
            if (item !== _this.CHARTER_PROMO) {
                resp.push(item);
            }
        });
        return resp;
    };
    SearchComponent.prototype.getListBoats = function (codigo) {
        var _this = this;
        this.parametro = {
            code: codigo
        };
        if (this.listCategories.length === 0 || this.listBoats.length === 0) {
            this.galavailServiceEcommer.getFleetByCodeCompany(this.parametro).subscribe(function (response) {
                var e_1, _a;
                _this.dataResponse = response;
                // console.log('DATO BARCOS>>>', this.dataResponse)
                var countLux = 0;
                var countFirst = 0;
                var countMid = 0;
                var countBudget = 0;
                try {
                    for (var _b = tslib_1.__values(_this.dataResponse), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var data = _c.value;
                        var item = {
                            codeBoat: data.codigo,
                            nameBoat: data.nombre,
                            startBoat: data.estrellas,
                            catBoat: data.categoria
                        };
                        _this.listBoats.push(item);
                        switch (data.categoria) {
                            case 5:
                                countLux++;
                                break;
                            case 4:
                                countFirst++;
                                break;
                            case 3:
                                countMid++;
                                break;
                            case 2:
                                countBudget++;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                _this.cruiseService.setCruisesList(_this.listBoats);
                // console.log('listado barcos', this.listBoats);
                if (countLux > 0) {
                    var itemCat = {
                        nameCategory: 'Luxury',
                        valueCategory: '5',
                        startCategory: '★★★★★'
                    };
                    _this.listCategories.push(itemCat);
                }
                if (countFirst > 0) {
                    var itemCat = {
                        nameCategory: 'First Class',
                        valueCategory: '4',
                        startCategory: '★★★★'
                    };
                    _this.listCategories.push(itemCat);
                }
                if (countMid > 0) {
                    var itemCat = {
                        nameCategory: 'Mid Range',
                        valueCategory: '3',
                        startCategory: '★★★'
                    };
                    _this.listCategories.push(itemCat);
                }
                if (countBudget > 0) {
                    var itemCat = {
                        nameCategory: 'Budget',
                        valueCategory: '2',
                        startCategory: '★★'
                    };
                    _this.listCategories.push(itemCat);
                }
            });
        }
        // console.log('listado Categorias', this.listCategories);
    };
    SearchComponent.prototype.setUrlOrigin = function () {
        this.galavailServiceEcommer.setLocalStorage('urlOrigen', this.buscador.empresa + '/' + this.buscador.barco + '/' + this.selectedLengthCruises.value + '/' + this.buscador.fecha + '/' + this.buscador.pasajeros);
    };
    SearchComponent.prototype.validatePassenger = function (valuePax) {
        return this.isCharterOnly ? "charterOnly" : Number(valuePax);
    };
    SearchComponent.prototype.getAllPassenger = function () {
        var index = this.cataloguePax.length;
        // return index >0 ? this.cataloguePax[index-1].code : "1";
        return "1";
    };
    SearchComponent.prototype.isSelectedCharterPromo = function () {
        var _this = this;
        var auxArray = this.selectedPromotions.value;
        var index = -1;
        try {
            index = auxArray.findIndex(function (item) { return item === _this.CHARTER_PROMO; });
        }
        catch (error) {
            index = -1;
        }
        return index >= 0 ? true : false;
    };
    SearchComponent.prototype.isSelectedPromoOnly = function () {
        var _this = this;
        var auxArray = this.selectedPromotions.value;
        var index = -1;
        try {
            index = auxArray.findIndex(function (item) { return item === _this.PROMO_ONLY; });
        }
        catch (error) {
            index = -1;
        }
        return index >= 0 ? true : false;
    };
    SearchComponent.prototype.isSelectedPromo2x1 = function () {
        var _this = this;
        var auxArray = this.selectedPromotions.value;
        var index = -1;
        try {
            index = auxArray.findIndex(function (item) { return item === _this.PROMO_2X1; });
        }
        catch (error) {
            index = -1;
        }
        return index >= 0 ? true : false;
    };
    SearchComponent.prototype.onChangePromotions = function () {
        var e_2, _a;
        this.isPromoOnly.emit(this.isSelectedPromoOnly());
        this.isPromo2x1.emit(this.isSelectedPromo2x1());
        if (this.isSelectedCharterPromo()) {
            this.promotionsMap.set(this.CHARTER_PROMO, true);
        }
        else if (!this.isSelectedCharterPromo()) {
            this.promotionsMap.set(this.CHARTER_PROMO, false);
        }
        if (this.isSelectedPromoOnly()) {
            this.promotionsMap.set(this.PROMO_ONLY, true);
        }
        else if (!this.isSelectedPromoOnly()) {
            this.promotionsMap.set(this.PROMO_ONLY, false);
        }
        if (this.isSelectedPromo2x1()) {
            this.promotionsMap.set(this.PROMO_2X1, true);
        }
        else if (!this.isSelectedPromo2x1()) {
            this.promotionsMap.set(this.PROMO_2X1, false);
        }
        try {
            for (var _b = tslib_1.__values(this.promotionsMap.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var entry = _c.value;
                if (entry[0] === this.CHARTER_PROMO && entry[1] === true) {
                    this.buscador.pasajeros = "charterOnly";
                    break;
                }
                if (entry[0] === this.CHARTER_PROMO && entry[1] === false && this.buscador.pasajeros === "charterOnly") {
                    this.buscador.pasajeros = this.cataloguePax[0].code;
                    break;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    SearchComponent.prototype.setDateTo = function (b) {
        var e = new Date(b);
        var toDate = new Date(e.getFullYear(), e.getMonth() + 1, e.getDate());
        this.dateTo.value <= e ? this.dateTo.setValue(toDate) : '';
        this.minDateTo = e;
        this.maxDateTo = new Date(e.getFullYear() + 1, e.getMonth(), e.getDate());
    };
    SearchComponent.prototype.formatDate = function (a) {
        var date = new Date(a);
        var dayString = date.getDate() < 10 ? '0' : '';
        var monthString = date.getMonth() < 9 ? '0' : '';
        var dateString = dayString + date.getDate().toString() + monthString + (date.getMonth() + 1).toString() + date.getFullYear().toString();
        return dateString;
    };
    return SearchComponent;
}());
export { SearchComponent };
export { ɵ0 };
